import { VisaIcon } from '@components/icons/VisaIcon';
import { CardIconContainer } from '../paymentMethod/components/PaymentsOptions.styles';
import { MasterCardIcon } from '@components/icons/MasterCardIcon';
import { RedCompraIcon } from '@components/icons/RedCompraIcon';
import Image from 'next/image';

interface CardIconProps {
  creditCardType?: string;
}

export function CardIcon(props: CardIconProps) {
  let icon: JSX.Element;

  switch (props.creditCardType) {
    case 'Visa':
      icon = <VisaIcon />;
      break;
    case 'MasterCard':
      icon = <MasterCardIcon />;
      break;
    case 'RedCompra':
      icon = <RedCompraIcon />;
      break;
    case 'Fintoc':
      icon = (
        <Image
          src="/assets/images/bankIcon.png"
          alt="bankIcon"
          height={30}
          width={30}
        />
      );
      break;
    case 'BancoEstado':
      icon = (
        <Image
          src="/assets/images/bancoEstadoLogo.png"
          alt="bancoEstadoLogo"
          height={30}
          width={30}
        />
      );
      break;
    default:
      icon = (
        <Image
          src="/assets/images/cardIcon.png"
          alt="bankIcon"
          height={30}
          width={30}
        />
      );
  }

  return <CardIconContainer>{icon}</CardIconContainer>;
}
